import { render, staticRenderFns } from "./strategies.vue?vue&type=template&id=18fcf138&"
import script from "./strategies.vue?vue&type=script&lang=js&"
export * from "./strategies.vue?vue&type=script&lang=js&"
import style0 from "./strategies.vue?vue&type=style&index=0&id=18fcf138&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports